let COMPANY_FREEDAYS = null;

function isAHoliday(day) {
    if (!COMPANY_FREEDAYS) return false;
    for (const fd of COMPANY_FREEDAYS) {
        if (fd.year == day.getFullYear() && fd.month == day.getMonth() && fd.day == day.getDate()) return true;
    }
    return false;
}

module.exports = {
    setCompanyFreedays(fd = []) {
        COMPANY_FREEDAYS = fd;
    },

    isWorkingDay(date) {
        const d = new Date(date);
        if (d.getDay() === 0 || d.getDay() === 6) return false;
        if (isAHoliday(d)) return false;
        return true;
    },


    /**
     * Dodaje do podanej daty
     * @param {Number} xDays ile dni roboczych dodac
     * @param {Date} [toDate] do tej daty
     */
    addWorkingDays: function(xDays, toDate) {
        const d = toDate ? new Date(toDate) : new Date();
        const isNegative = xDays < 0;

        for (let i = 0; i < Math.abs(xDays); i++) {
            isNegative ? d.setDate(d.getDate() - 1) : d.setDate(d.getDate() + 1);
            // jesli sobota lub niedziela
            while (d.getDay() == 6 || d.getDay() == 0 || isAHoliday(d)) {
                isNegative ? d.setDate(d.getDate() - 1) : d.setDate(d.getDate() + 1);
            }
        }

        return d;
    },

    /**
     * Konwertuje czas trwania w sekundach na czytelny string
     * @param {Number} totalSeconds   laczna liczba sekund
     * @param {boolean} [showSeconds] czy w koncowym strinug wyswietlac tez sekundy
     * @returns Czas trwania jako string w formacie HH:mm:ss
     */
    convertSecondsToHumanReadableString(totalSeconds, showSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const leftSeconds = totalSeconds % 3600;
        const minutes = Math.floor(leftSeconds / 60);
        const seconds = leftSeconds % 60;

        let readableString = String(hours).padStart(2, '0') + ":" + String(minutes).padStart(2, '0');
        if (showSeconds) readableString += ":" + String(seconds).padStart(2, '0');

        return readableString;
    },

    /**
     * Wyciaga zmienna z obiektu jako numer
     * @param {object} obj
     * @param {string} key
     * @returns {Number} integer, 0 if key does not exists
     */
    getIntFromObject(obj, key) {
        if (!obj[key]) return 0;
        return parseInt(obj[key]);
    },

    deepCopy(obj) {
        return JSON.parse(JSON.stringify(obj));
    },

    isEmail(email) {
        if (typeof email != 'string') return false;
        if (email.length == 0) return false;

        const parts = email.split('@');
        if (parts.length != 2) return false;

        const addr = parts[0];
        const host = parts[1];
        if (addr.length < 1 || host.length < 3) return false;
        if (host.indexOf('.') == -1) return false;

        return true;
    },

    formatTemplateContentForEditor(content) {
        if (!content) return '';

        return String(content)
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .replace(/\n/g, '<br>');
    },

    zeroPrefix(num, digit) {
        let zero = '';
        for (let i = 0; i < digit; i++) {
            zero += '0';
        }
        return (zero + num).slice(-digit);
    },

    getFullWarehouseName(whId, allWarehouses) {
        const parents = [];
        const wh = allWarehouses.find(w => w._id == whId);
        if (!wh) return "brak";
        if (!wh.parent) return wh.name;

        let parent = allWarehouses.find(w => w._id == wh.parent);
        while (parent) {
            parents.push(parent);
            parent = parent.parent ? allWarehouses.find(w => w._id == parent.parent) : null;
        }

        parents.unshift(wh);
        const title = parents.map(wh => wh.name).reverse().join(' > ');
        return title;
    },

    stringToHex(str) {
        let hash = 0;
        if (str.length === 0) return "#000000";
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
            hash = hash & hash;
        }
        let color = '#';
        for (let i = 0; i < 3; i++) {
            const value = (hash >> (i * 8)) & 255;
            color += value.toString(16).padStart(2, '0');
        }
        return color;
    },

    /**
     * Wyszukuje receptę dla danego produktu na podstawie jego cech
     * i warunków recept. Przepis musi pasować do wszystkich cech produktu.
     * @param {object} featureMap mapa cech produktu { kod_cechy: wartosc }
     * @param {object[]} recipes
     * @returns {object} recipe
     */
    matchRecipeForFeatureMap(featureMap, recipes) {
        if (typeof featureMap != 'object' || Object.keys(featureMap).length == 0) return null;
        if (!Array.isArray(recipes)) return null;
        if (recipes.length == 0) return null;
        if (recipes.length == 1) return recipes[0];

        const sorted = [...recipes].sort((a, b) => {
            return b.conditions.length - a.conditions.length;
        });

        for (const recipe of sorted) {
            let isValid = true;
            for (const cond of recipe.conditions) {
                if (cond.operator == 'eq') {
                    if (featureMap[cond.feature] != cond.value) isValid = false;
                } else if (cond.operator == 'neq') {
                    if (featureMap[cond.feature] == cond.value) isValid = false;
                } else if (cond.operator == 'lt') {
                    if (featureMap[cond.feature] >= cond.value) isValid = false;
                } else if (cond.operator == 'gt') {
                    if (featureMap[cond.feature] <= cond.value) isValid = false;
                } else if (cond.operator == 'range') {
                    const range = cond.value.split('-');
                    if (featureMap[cond.feature] < range[0] || featureMap[cond.feature] > range[1]) isValid = false;
                }
            }

            if (isValid) return recipe;
        }
    },

    /**
     * Tłumaczy featureId na mapę cech
     * @param {string} featureId feature id string e.g. "filtr_kasetowy;grubosc=100;jedna_siatka=TAK;klasa_filtra=G4;klasa_filtra_iso=Coarse 65%;szerokosc=287;wysokosc=490;zwiekszona_powierzchnia=-1;"
     * @returns {object} mapa cech { kod_cechy: wartosc }
     */
    parseFeaturesId(featureId) {
        if (typeof featureId != 'string') return null;
        if (featureId.length == 0) return null;

        const features = featureId.split(';');
        const featureMap = {};
        for (const feature of features) {
            if (feature.length == 0) continue;
            const parts = feature.split('=');
            if (parts.length != 2) continue;
            const key = parts[0].trim();
            const value = parts[1].trim();
            if (key.length == 0 || value.length == 0) continue;

            featureMap[key] = isNaN(value) ? value : Number(value);
        }

        return featureMap;
    },

    // conver string like 15min or hour or day to seconds
    relativeTimeToSeconds(timeString) {
        if (typeof timeString != 'string') return 0;
        timeString = timeString.trim().toLowerCase();

        const timeUnits = {
            s: 1,
            sec: 1,
            sek: 1,
            sekund: 1,
            min: 60,
            hour: 3600,
            godz: 3600,
            godzina: 3600,
            godziny: 3600,
            godzin: 3600,
            dzien: 86400,
            day: 86400,
            dni: 86400
        };

        const parts = timeString.split(' ');
        let totalSeconds = 0;

        for (const part of parts) {
            const match = part.match(/^(\d*)([a-z]+)$/);
            if (!match) continue;

            const value = parseInt(match[1]) || 1; // Default to 1 if no number is specified
            const unit = match[2];

            if (timeUnits[unit]) {
                totalSeconds += value * timeUnits[unit];
            }
        }

        return totalSeconds;
    }

};
